<template>
  <section class="innerpages animate__animated animate__slideInRight">
    <div class="container ">
      <div class="row">
        <div class="col-md-12">
          <div class="filterTabs">
            <!-- List group -->
            <ul class="nav nav-pills nav-fill" id="myList" role="tablist">
              <li class="nav-item" v-for="tab in tabs">
                <a class="nav-link" :class="{ active: tab.key === activeTab }" data-toggle="tab" @click="openTab(tab)"
                  role="tab">{{ tab.label }}</a>
              </li>
            </ul>
            <!-- Tab panes -->
            <div class="tab-content">
              <div v-for="(tab, key) in tabs" class="tab-pane animate__animated animate__slideInRight"
                :class="{ active: tab.key === activeTab }" :id="tab.key" role="tabpanel">
                <div class="show-filter" v-if="tab.showPicker">
                  <div class="row">
                    <div class="col-5 pr-2">
                      <div class="filterWrapper">
                        <input type="text" class="form-control " placeholder="Start Date" id="stDatePicker" />
                        <svg xmlns="http://www.w3.org/2000/svg" width="10.377" height="10.371"
                          viewBox="0 0 10.377 10.371">
                          <g transform="translate(0 -1.991)">
                            <g transform="translate(0 8.665)">
                              <path class="a" d="M1.192,353.28,0,356.976l3.7-1.192Z" transform="translate(0 -353.28)" />
                            </g>
                            <g transform="translate(2.03 1.991)">
                              <g transform="translate(0 0)">
                                <rect class="a" width="8.227" height="3.577"
                                  transform="translate(0 5.817) rotate(-45)" />
                              </g>
                            </g>
                            <g transform="translate(7.144 1.998)">
                              <path class="a"
                                d="M376.8,1.848,375.131.179a.576.576,0,0,0-.835,0l-.537.537,2.5,2.5.537-.537A.576.576,0,0,0,376.8,1.848Z"
                                transform="translate(-373.76 0)" />
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div class="col-5 pl-2 ">
                      <div class="filterWrapper">
                        <input type="text" class="form-control" placeholder="End Date" id="endDatePicker" />
                        <svg xmlns="http://www.w3.org/2000/svg" width="10.377" height="10.371"
                          viewBox="0 0 10.377 10.371">
                          <g transform="translate(0 -1.991)">
                            <g transform="translate(0 8.665)">
                              <path class="a" d="M1.192,353.28,0,356.976l3.7-1.192Z" transform="translate(0 -353.28)" />
                            </g>
                            <g transform="translate(2.03 1.991)">
                              <g transform="translate(0 0)">
                                <rect class="a" width="8.227" height="3.577"
                                  transform="translate(0 5.817) rotate(-45)" />
                              </g>
                            </g>
                            <g transform="translate(7.144 1.998)">
                              <path class="a"
                                d="M376.8,1.848,375.131.179a.576.576,0,0,0-.835,0l-.537.537,2.5,2.5.537-.537A.576.576,0,0,0,376.8,1.848Z"
                                transform="translate(-373.76 0)" />
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div class="col-2 pl-0 pr-0">
                      <div class="filterWrapper">
                        <button class="btn btn-outline btnFilter" @click="loadTabData">Apply</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card lead-table">
                  <b-table :items="masterData" :fields="fields" :fixed="true" :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc" sort-icon-right responsive="sm" show-empty @row-clicked="openDetails"
                    tbody-tr-class="dataDivider" id="mcr-table">
                    <template v-slot:empty="scope">
                      <h5 class="noData">No Data</h5>
                    </template>
                    <template v-slot:cell(total_leads)="data">
                      <i style="font-style:normal">{{ data.value }}
                        <span class="icon-arrow">
                          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436"
                            style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve">
                            <polygon
                              points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 ">
                            </polygon>
                          </svg>
                        </span>
                      </i>
                    </template>
                    <template v-if="masterData?.data?.length" #table-caption>Number of rows:
                      {{ masterData.data.length }}</template>
                  </b-table>
                  <b-pagination v-if="totalRows > perPage" v-model="currentPage" :per-page="perPage"
                    :total-rows="totalRows" align="center" aria-controls="mcr-table"></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Rolldate from 'rolldate';
export default {
  data() {
    return {
      tabs: [
        { label: "Today", key: "today", start: 0, end: 0 },
        { label: "Yesterday", key: "yesterday", start: 1, end: 1 },
        { label: "30 Days", key: "thirtyD", start: 30, end: 0 },
        { label: "Custom", key: "custom", showPicker: true }
      ],
      currentPage: 1,
      firstReload: true,
      sortBy: 'total',
      sortDesc: true,
      fields: [
        { key: 'sub_project_name', label: "Project", sortable: true },
        { key: 'enquiry_source_name', label: "Source", sortable: true },
        { key: 'total_leads', label: "Leads", sortable: true },
      ],
      masterData: [],
      pagination: null,
    }
  },
  created() {
    const tab = localStorage.getItem('selectedtabkey')
    this.tabDefaults.tab = tab || 'today';
    this.loadTabData();
    this.$store.dispatch('setActiveTitle', "Marketing Campaign Report");
    this.tabDefaults.searchFn = this.loadTabData;
  },
  mounted() {
    this.initRollDate()
    this.$store.dispatch('setSelectedSources', [1])
  },
  watch: {
    // $route(to, from) {
    //   this.loadTabData();
    // },
    currentPage() {
      this.loadTabData();
    }
  },
  methods: {
    initRollDate() {
      let vm = this;
      let srd = new Rolldate({
        el: '#stDatePicker',
        format: 'DD-MM-YYYY',
        beginYear: 2012,
        endYear: vm.$moment().year(),
        confirm: vm.logStartInput,
        value: this.$moment().subtract(this.tabDefaults.rSt, 'd').format('YYYY-MM-DD'),
        lang: {
          title: ' ',
          cancel: 'Cancel',
          confirm: 'Done',
          year: '',
          month: '',
          day: ''
        }
      });
      let erd = new Rolldate({
        el: '#endDatePicker',
        format: 'DD-MM-YYYY',
        beginYear: 2012,
        endYear: vm.$moment().year(),
        confirm: vm.logEndInput,
        value: this.$moment().subtract(this.tabDefaults.rEnd, 'd').format('YYYY-MM-DD'),
        lang: {
          title: ' ',
          cancel: 'Cancel',
          confirm: 'Done',
          year: '',
          month: '',
          day: ''
        }
      });
    },
    openTab(tab) {
      this.tabDefaults.tab = tab.key
      this.loadTabData();
      localStorage.setItem('selectedtabkey', tab.key);
    },
    logStartInput(date) {
      let diff = this.$moment().diff(this.$moment(date, 'DD-MM-YYYY'), 'days')
      this.tabDefaults.rSt = diff
    },
    logEndInput(date) {
      let diff = this.$moment().diff(this.$moment(date, 'DD-MM-YYYY'), 'days')
      this.tabDefaults.rEnd = diff
    },
    openDetails(data) {
      const activeItem = {
        sub_project_id: data.sub_project_id,
        enquiry_source_id: data.enquiry_source_id
      };
      this.$store.dispatch('setActiveItem', activeItem);
      this.$router.push({
        name: "MarketingCampaignDetails",
        query: this.$route.query
      });
    },
    loadTabData() {
      const query = this.$route.query;
      let dateFrom = ''
      let dateTo = ''
      let sourceIds = ''
      let projectIds = ''
      let sub_project_ids = ''
      let ad_group_ids = ''
      let campaign_ids = ''
      let physical_pincodes = ''
      let utm_campaigns = ''
      let devices = ''
      let ad_strategies = ''
      let keyword_types = ''
      let ads_names = ''
      if (this.firstReload) {
        dateFrom = query.start_date ? query.start_date : this.defaultStartDate.format('YYYY-MM-DD');
        dateTo = query.end_date ? query.end_date : this.defaultStartDate.format('YYYY-MM-DD');
        sourceIds = this.$store.getters.selectedSources.join(',') || query.source_ids || 1;
        sub_project_ids = this.$store.getters.subProjects.join(',') || query.sub_project_ids;
        ad_group_ids = this.$store.getters.adGroups.join(',') || query.ad_group_ids;
        campaign_ids = this.$store.getters.campaigns.join(',') || query.campaign_ids;
        physical_pincodes = this.$store.getters?.physicalPincode || query.physical_pincodes;
        projectIds = this.$store.getters.selectedProjectIds.join(',') || query.project_ids;
        utm_campaigns = this.$store.getters.utmCampaigns|| query.utm_campaigns;
        devices = this.$store.getters.devices|| query.devices;
        ad_strategies = this.$store.getters.adStrategies || query.ad_strategies;
        keyword_types = this.$store.getters.keywordTypes || query.keyword_types;
        ads_names = this.$store.getters.adsNames|| query.ads_names;
      } else {
        dateFrom = this.defaultStartDate.format('YYYY-MM-DD');
        dateTo = this.defaultEndDate.format('YYYY-MM-DD');
        sourceIds = this.$store.getters.selectedSources.join(',');
        sub_project_ids = this.$store.getters.subProjects.join(',');
        ad_group_ids = this.$store.getters.adGroups.join(',');
        campaign_ids = this.$store.getters.campaigns.join(',');
        physical_pincodes = this.$store.getters?.physicalPincode;
        projectIds = this.$store.getters.selectedProjectIds.join(',');
        utm_campaigns = this.$store.getters.utmCampaigns,
        devices = this.$store.getters.devices,
        ad_strategies = this.$store.getters.adStrategies,
        keyword_types = this.$store.getters.keywordTypes,
        ads_names = this.$store.getters.adsNames;
      }
      this.$store.dispatch('setDefaultDates', { from: dateFrom, upto: dateTo });
      let queryParams = {
        start_date: dateFrom,
        end_date: dateTo,
        source_ids: sourceIds,
        sub_project_ids: sub_project_ids,
        ad_group_ids: ad_group_ids,
        campaign_ids: campaign_ids,
        physical_pincodes: physical_pincodes,
        utm_campaigns: utm_campaigns,
        devices: devices,
        ad_strategies: ad_strategies,
        keyword_types: keyword_types,
        ads_names: ads_names,
        project_ids: projectIds
      };
      Object.keys(queryParams).forEach(key => {
        if (!queryParams[key]) delete queryParams[key];
      });
      if (JSON.stringify(this.$route.query) !== JSON.stringify(queryParams)) {
        this.$router.push({ path: this.$route.path, query: queryParams });
      }
      let searchParams = new URLSearchParams(queryParams).toString();
      let url = `/marketing_campaign_report_summary?${searchParams}&page=${this.currentPage}`
      this.$axios.get(url)
        .then(res => {
          if (res) {
            this.masterData = res.data.data;
            this.pagination = res.data.pagination;
            this.$store.dispatch('setMtrFilters', res.data.settings);
            this.firstReload = false
          }
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
    },
  },
  computed: {
    perPage() {
      return this.pagination?.per_page || 30;
    },
    totalRows() {
      return this.pagination?.total_count || 0;
    },
    activeTabHash() {
      let ah = this.tabs.find(el => el.key === this.activeTab)
      if (ah.key === "custom") {
        ah.start = this.tabDefaults.rSt
        ah.end = this.tabDefaults.rEnd
      }
      return ah
    },
    defaultStartDate() {
      return this.$moment().subtract(this.activeTabHash.start, 'd')
    },
    defaultEndDate() {
      return this.$moment().subtract(this.activeTabHash.end, 'd')
    },
    activeTab() {
      return this.tabDefaults.tab;
    },
    tabDefaults() {
      return this.$store.getters.sDefaults;
    },
    sSources(){
      return this.$store.getters.selectedSources;
    },
  }
}
</script>